import { FieldOrigin, isCustomOrigin, LoanFieldProps } from 'config'
import { extendedFieldOriginOptions } from 'pages/Admin/AdminTools/Configuration/LoanFieldsProperties/inputs'

export const getLoanFieldSubmenuTitle = (fieldOrigin: string, loanFields?: LoanFieldProps) => {
  const customTitles: Record<string, string> = loanFields?.customTitle || {}
  let title = customTitles[fieldOrigin as FieldOrigin] || ''

  if (!title && isCustomOrigin(fieldOrigin)) {
    title = extendedFieldOriginOptions[FieldOrigin.CustomInformation]
  }

  return title || extendedFieldOriginOptions[fieldOrigin as FieldOrigin] || fieldOrigin
}

export const getLoanFieldSubMenus = (loanFields?: LoanFieldProps): Record<string, { title: string }> => {
  const properties = loanFields?.properties || {}
  const entries: Record<string, { title: string }> = {}

  Object.entries(properties).forEach(([fieldOrigin, property]: [string, any]) => {
    if (property?.sectionType !== 'SubMenu') return
    entries[fieldOrigin] = { title: getLoanFieldSubmenuTitle(fieldOrigin, loanFields) }
  })

  return entries
}
